export default "__VITE_ASSET__dIySzHSE__"